export const UPDATE_CONFIG = {
  VERSION_URL: 'assets/version.json',
  POLL_INTERVAL_MS: 60_000,
  INITIAL_DELAY_MS: 5_000,
  FETCH_TIMEOUT_MS: 8_000,
  WARNING_DURATION_MS: 5 * 60 * 1000,
  COUNTDOWN_TICK_MS: 1_000,
  ACCEPTED_VERSION_KEY: 'app-accepted-version',
  DETECTED_VERSION_KEY: 'app-update-detected-version',
  DETECTED_AT_KEY: 'app-update-detected-at',
} as const;

export interface VersionPayload {
  version: string;
  buildAt: string;
}

export const UPDATE_STATE = {
  IDLE: 'idle',
  WARNING: 'warning',
  BLOCKING: 'blocking',
} as const;
export type UpdateState = (typeof UPDATE_STATE)[keyof typeof UPDATE_STATE];

export const UPDATE_STEP = {
  IDLE: 'idle',
  CLEARING_CACHE: 'clearing-cache',
  CLOSING_SESSION: 'closing-session',
  RELOADING: 'reloading',
} as const;
export type UpdateStep = (typeof UPDATE_STEP)[keyof typeof UPDATE_STEP];

export const UPDATE_STEP_MS = {
  CLEARING_CACHE: 900,
  CLOSING_SESSION: 700,
  RELOADING: 600,
} as const;

export interface UpdateStepDescriptor {
  key: UpdateStep;
  label: string;
  description: string;
  icon: string;
}

export const UPDATE_STEPS: readonly UpdateStepDescriptor[] = [
  {
    key: UPDATE_STEP.CLEARING_CACHE,
    label: 'Limpiando caché del sistema',
    description: 'Eliminando archivos antiguos del navegador.',
    icon: 'broom',
  },
  {
    key: UPDATE_STEP.CLOSING_SESSION,
    label: 'Cerrando sesión actual',
    description: 'Por seguridad, refrescamos tu sesión.',
    icon: 'lock',
  },
  {
    key: UPDATE_STEP.RELOADING,
    label: 'Cargando la nueva versión',
    description: 'Casi listo, esto solo tomará un instante.',
    icon: 'rocket',
  },
];
